import React from "react";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { BookOpen, Download, FileText } from "lucide-react";
import heroIcon from "../../assets/layer-icon.png";

const GUIDE_URL = "https://drive.google.com/drive/folders/1te3s-hRdBVVixlayjtcpVUwP2OPDyK7e";
const TEMPLATE_URL = "https://drive.google.com/drive/folders/1EJwhmhIl_K4tNWn2xjOA7DizNkjiy-Pn";
const BOOKLET_URL = "/ideathon_kitapcik.pdf";

export const AboutSection: React.FC = () => {
  const stats = [
    { value: 4, label: "Maksimum Ekip Üyesi", suffix: "" },
    { value: 5, label: "Odak Alanı", suffix: "" },
    { value: 5, label: "Sunum Dakikası", suffix: "" },
    { value: 3, label: "Soru-Cevap Dakikası", suffix: "" },
  ];

  return (
    <section id="about" className="section-shell bg-[var(--bg-secondary)]">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto text-center"
        >
          <img
            src={heroIcon}
            alt="Etkinlik ikonu"
            className="mx-auto mb-1 h-20 w-20 sm:h-24 sm:w-24 object-contain"
            style={{ objectPosition: "58% center" }}
          />
          <h2 className="text-4xl sm:text-5xl font-black mb-4 leading-[1.05] tracking-[-0.02em]">
            <span className="text-[var(--text-primary)]">Tarım Ideathonu</span>
          </h2>
          <div className="w-24 h-1 mx-auto rounded-full mb-6 bg-[#73E03A]" />
          <p className="text-[var(--text-secondary)] text-base sm:text-lg leading-relaxed">
            Konya Büyükşehir Belediyesi Kapsül Teknoloji Platformu ve MEVKA iş birliğinde düzenlenen Tarım
            Teknolojileri Ideathonu; yenilikçi, uygulanabilir ve sürdürülebilir fikirlerin
            geliştirilmesini destekler. Katılımcılar sektör temsilcileri, ekosistem
            paydaşları ve uzman jüri üyeleriyle bir araya gelerek projelerini geliştirme
            ve sunma fırsatı bulur.
          </p>
          <p className="mt-4 text-sm text-[var(--text-secondary)]">
            Tarih: 11 Nisan 2026 · Yer: Kapsül Teknoloji Platformu Zindankale Yerleşkesi
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <a
              href={GUIDE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-5 py-2.5 rounded-xl border no-underline font-semibold text-sm sm:text-base shadow-[0_10px_24px_rgba(18,38,10,0.32)] hover:scale-[1.02] transition"
              style={{
                color: "#F4FFE9",
                borderColor: "rgba(166,238,108,0.55)",
                backgroundColor: "#2D621A",
              }}
            >
              Yarışma Kılavuzu (PDF)
            </a>
            <a
              href={TEMPLATE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-5 py-2.5 rounded-xl border no-underline font-semibold text-sm sm:text-base shadow-[0_10px_24px_rgba(18,38,10,0.2)] hover:scale-[1.02] transition"
              style={{
                color: "#245314",
                borderColor: "rgba(88,176,46,0.5)",
                backgroundColor: "rgba(233,247,223,0.95)",
              }}
            >
              Sunum Şablonu
            </a>
          </div>
        </motion.div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((item, idx) => (
            <motion.div
              key={item.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -6, scale: 1.02 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.08, type: "spring", stiffness: 220, damping: 18 }}
              className="kapsul-card p-5 text-center"
            >
              <div className="text-3xl font-black text-[var(--accent-primary)] dark:text-white">
                <CountUp end={item.value} duration={1.8} />{item.suffix}
              </div>
              <div className="text-sm text-[var(--text-secondary)] mt-1">{item.label}</div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="mt-10 kapsul-card p-6 sm:p-8 border"
          style={{ borderColor: "rgba(115,224,58,0.35)" }}
        >
          <div className="grid grid-cols-1 md:grid-cols-[auto_1fr_auto] gap-6 items-center">
            <div
              className="mx-auto md:mx-0 flex items-center justify-center h-20 w-20 rounded-2xl border shrink-0"
              style={{
                borderColor: "rgba(115,224,58,0.4)",
                background: "linear-gradient(145deg, rgba(115,224,58,0.15), rgba(232,247,224,0.6))",
              }}
            >
              <BookOpen className="w-10 h-10 text-[#2D621A]" />
            </div>

            <div className="text-center md:text-left">
              <h3 className="text-xl sm:text-2xl font-bold text-[var(--text-primary)] mb-1">
                Proje Kitapçığı
              </h3>
              <p className="text-sm text-[var(--text-secondary)] flex items-center justify-center md:justify-start gap-2 flex-wrap">
                <FileText className="w-4 h-4 text-[#57B92B]" />
                <span>Etkinlikte yer alan tüm katılımcı projeleri</span>
              </p>
            </div>

            <div className="flex flex-wrap gap-2 sm:gap-3 justify-center md:justify-end">
              <a
                href={BOOKLET_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl border no-underline font-semibold text-sm shadow-[0_10px_24px_rgba(18,38,10,0.32)] hover:scale-[1.02] transition"
                style={{
                  color: "#F4FFE9",
                  borderColor: "rgba(166,238,108,0.55)",
                  backgroundColor: "#2D621A",
                }}
              >
                <BookOpen className="w-4 h-4" />
                Görüntüle
              </a>
              <a
                href={BOOKLET_URL}
                download
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl border no-underline font-semibold text-sm shadow-[0_10px_24px_rgba(18,38,10,0.2)] hover:scale-[1.02] transition"
                style={{
                  color: "#245314",
                  borderColor: "rgba(88,176,46,0.5)",
                  backgroundColor: "rgba(233,247,223,0.95)",
                }}
              >
                <Download className="w-4 h-4" />
                İndir
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
